/**
 * Minimum number of PUBLISHED reviews a teacher/offering needs before an
 * aggregate score is shown instead of a "New" badge. Mirrors the backend
 * `reviews.min-count` default (cluster 3); keep the two in sync by hand.
 *
 * Kept in its own module (not featureFlags.ts) so component tests that mock
 * `@/config/featureFlags` still read the real constant.
 */
export const REVIEW_MIN_COUNT = 3;
